import React from 'react';

import { BetSummaryProps, BetSummarySection, BetSummarySectionProps } from '@/components/BetSummarySection';
import { usePotentialPayout } from '@/feature/bets-sbk/hooks/use-potential-payout';
import { isVoidedResult } from '@/feature/bets-sbk/utils/is-voided-result';
import { useFormatCurrency } from '@/hooks/use-format-currency';

import { useBetDetailsVoidedBetSummary, useSettledPayoutSummary, useSharedBetDetailsBetSummary } from './utils';

/**
 * Helper Hooks
 */
const useBetDetailsOpenSingleBetSummary = (props: BetSummaryProps): BetSummarySectionProps => {
    const { bet } = props;
    const { formatCurrency } = useFormatCurrency();
    const payout = usePotentialPayout(bet);
    return {
        ...useSharedBetDetailsBetSummary(props),
        body3Text: formatCurrency(payout),
        ...props.betSummarySectionProps,
    };
};

const useBetDetailsSettledSingleBetSummary = (props: BetSummaryProps): BetSummarySectionProps => ({
    ...useSharedBetDetailsBetSummary(props),
    ...useSettledPayoutSummary(props.bet),
    ...props.betSummarySectionProps,
});

/**
 * Components
 */
const OpenSingleBetSummary = (props: BetSummaryProps) => (
    <BetSummarySection {...useBetDetailsOpenSingleBetSummary(props)} />
);

const VoidedSingleBetSummary = (props: BetSummaryProps) => (
    <BetSummarySection {...useBetDetailsVoidedBetSummary(props)} />
);

const SettledSingleBetSummary = (props: BetSummaryProps) => (
    <BetSummarySection {...useBetDetailsSettledSingleBetSummary(props)} />
);

export const SingleBetSummarySection = (props: BetSummaryProps) => {
    const { bet } = props;
    if (isVoidedResult(bet.result)) {
        return <VoidedSingleBetSummary {...props} />;
    }
    switch (bet.result) {
        case 'WON':
        case 'LOST':
        case 'CASHEDOUT':
            return <SettledSingleBetSummary {...props} />;
        default:
            return <OpenSingleBetSummary {...props} />;
    }
};
